import { useEffect } from 'react'
import './landing.styles.scss'

import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component';
import BrandLogo from '@/components/SHARED/brand-logo/brand-logo.component';

// The front door, in the Hardwood look.
const LandingPage = () => {

    const currentUser = useSelector(state => state.userData.currentUser);
    const navigate = useNavigate();

    useEffect(() => {
        if (currentUser) navigate('/loading');
    }, [currentUser, navigate])

    return (
        <UnauthLayout>
            <div className='landing-page'>
                <section className='landing-hero'>
                    {/* Half-court lines behind the logo. */}
                    <svg className='court-lines' viewBox='0 0 600 300' aria-hidden='true'>
                        <path d='M0 300V0' />
                        <circle cx='0' cy='150' r='70' />
                        <path d='M600 20H520a130 130 0 0 0 0 260H600' />
                        <rect x='470' y='95' width='130' height='110' />
                    </svg>
                    <BrandLogo theme='hardwood' tone='light' size='hero' />
                    <p className='landing-pitch'>
                        Run a basketball team. Set the lineup, find the chemistry, and chase a title one game day at a time.
                    </p>
                    <div className='landing-actions'>
                        <button className='g-button primary' onClick={() => navigate(currentUser ? '/loading' : '/signin')}>
                            {currentUser ? 'Go to my team' : 'Sign in to play'}
                        </button>
                        <Link to='/how-it-works' className='g-button'>How it works</Link>
                    </div>
                </section>

                <section className='landing-points'>
                    <div className='point'>
                        <h3>College or pro</h3>
                        <p>College leagues of about 150 teams with conference tournaments and a 64-team national tournament, or tighter pro leagues with playoff series.</p>
                    </div>
                    <div className='point'>
                        <h3>Chemistry wins games</h3>
                        <p>Talent matters, but a team that fits together can beat a better team that doesn’t. Finding the right five is up to you.</p>
                    </div>
                    <div className='point'>
                        <h3>A game every day</h3>
                        <p>Games are played for you once a day, possession by possession, with box scores, play-by-play and rankings.</p>
                    </div>
                </section>
            </div>
        </UnauthLayout>
    )
}

export default LandingPage;
